module.exports = __webpack_public_path__ + "img/Cajas_2.0826cc09.jpg";